export default __webpack_public_path__ + "static/media/N11.687ac597.png";